import { types } from 'mobx-state-tree';

import { loadable } from '../mobx-utils';
import { urls } from '../urls';
import { fetchApiEndpoint } from './flows/get-api-endpoint';
import { DateTime } from '../mobx-utils/types/date-time';

export const DocumentModel = types.model('Document', {
  version: types.maybe(types.string),
  createdAt: types.maybe(DateTime),
  link: types.string,
  type: types.string,
});

// prettier-ignore
export const DocumentStore = types.model('DocumentStore', {
  documents: loadable(
    types.array(DocumentModel),
    fetchApiEndpoint(urls.api.documents),
  ),
});
